interface Case {
  id: number;
  name: string;
  year: string;
  image: string;
  description: string;
  service: string;
  client: string;
  date: string;
  technology: string;
}

// Sample case data
export const cases: Case[] = [
  {
    id: 1,
    name: "E-commerce Platform",
    year: "2023",
    image: "/images/cases/showcase_1.jpg",
    description:
      "Successfully launched a scalable e-commerce platform serving thousands of customers daily with seamless user experience and robust backend.",
    service: "Web Development, E-commerce",
    client: "Retail Business",
    date: "January 2023",
    technology: "React, Node.js, MongoDB",
  },
  {
    id: 2,
    name: "Mobile App Development",
    year: "2023",
    image: "/images/cases/showcase_2.jpg",
    description:
      "Executed a multi-channel digital marketing campaign that increased client sales by 200% in just three months.",
    service: "Mobile Development",
    client: "Tech Startup",
    date: "March 2023",
    technology: "React Native, Firebase",
  },
  {
    id: 3,
    name: "Digital Marketing Campaign",
    year: "2022",
    image: "/images/cases/showcase_3.jpg",
    description:
      "Received the Retail Innovation Award for outstanding technology solutions in the retail sector.",
    service: "Digital Marketing",
    client: "Fashion Brand",
    date: "September 2022",
    technology: "Google Ads, Facebook Ads, Analytics",
  },
  {
    id: 4,
    name: "Brand Identity Design",
    year: "2022",
    image: "/images/cases/showcase_4.jpg",
    description:
      "Expanded operations to five new countries, establishing a strong international presence and local partnerships.",
    service: "Brand Identity, Design",
    client: "Saudi Venture Capital",
    date: "January 2025",
    technology: "Figma, WordPress",
  },
  {
    id: 5,
    name: "Web Application",
    year: "2021",
    image: "/images/cases/showcase_1.jpg",
    description: "Enterprise web solution",
    service: "Web Development",
    client: "Enterprise Client",
    date: "November 2021",
    technology: "Vue.js, Python, PostgreSQL",
  },
  {
    id: 6,
    name: "Consulting Project",
    year: "2021",
    image: "/images/cases/showcase_2.jpg",
    description: "Business strategy and optimization",
    service: "Business Consulting",
    client: "Softakey Digital Agency",
    date: "July 2021",
    technology: "Strategy Tools, Analytics",
  },
];
